import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Image = props => {
  return (
    <div
      className={classNames('img-container', props.className, {
        'fix-height': props.hasFixHeight,
        'full-width': props.imgHasFullWidth,
        'with-background': props.hasBackground,
      })}
      onClick={props.onClick}
    >
      <img
        className={classNames('image', {
          'img-hover': props.hasHoverEffect,
          'full-width': props.imgHasFullWidth,
        })}
        src={props.src}
      />
      {props.hasProtectionOverlay && (
        <div
          className={classNames('protection-overlay', {
            'protection-overlay-hover': props.hasHoverEffect,
          })}
        />
      )}
      {props.bottomLeftElement && (
        <div className="img-element bottom-left">{props.bottomLeftElement}</div>
      )}
      {props.topRightElement && (
        <div className="img-element top-right">{props.topRightElement}</div>
      )}
    </div>
  );
};

Image.defaultProps = {
  hasBackground: true,
  hasHoverEffect: true,
  hasFixHeight: false,
  hasProtectionOverlay: true,
  imgHasFullWidth: false,
};

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  hasBackground: PropTypes.bool,
  hasHoverEffect: PropTypes.bool,
  hasFixHeight: PropTypes.bool,
  hasProtectionOverlay: PropTypes.bool,
  imgHasFullWidth: PropTypes.bool,
  bottomLeftElement: PropTypes.node,
  topRightElement: PropTypes.node,
  onClick: PropTypes.func,
};

export default Image;
